// extracted by mini-css-extract-plugin
export default {"container":"page_container__2rt6g","backgroundTitle":"page_backgroundTitle__1TfJy","title":"page_title__1uQqq"};